import BenefitCreatedEvent from '@/domains/benefits/events/BenefitCreatedEvent';

const BenefitEvents = {
  BenefitCreated: BenefitCreatedEvent,
};

export default BenefitEvents;
